import {useEffect, useRef} from 'react';

export const useInputFocus = ( isFocused ) => {
    const fieldRef = useRef();

    useEffect( () => {
        if ( isFocused ) {
            setTimeout( () => fieldRef.current?.focus(), 10 )
        }
    }, [] );

    return {fieldRef};
}


